// extracted by mini-css-extract-plugin
export var dropdownContainer = "_4y-5";
export var imageContainer = "_4y-4";
export var metricsGrid = "_4y-2";
export var productDetailContainer = "_4y-1";
export var productListContainer = "_4y-0";
export var subscriberTableContainer = "_4y-3";